/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiKeycloakSetUserPasswordGet$Json$Params {
  userId?: string;
  Authorization?: string;
}

export function apiKeycloakSetUserPasswordGet$Json(http: HttpClient, rootUrl: string, params?: ApiKeycloakSetUserPasswordGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, apiKeycloakSetUserPasswordGet$Json.PATH, 'get');
  if (params) {
    rb.query('userId', params.userId, {});
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

apiKeycloakSetUserPasswordGet$Json.PATH = '/api/keycloak/SetUserPassword';
